// src/admin/components/ModalSearchBar.js
import React from 'react';
import PropTypes from 'prop-types';
import SearchField from '../../shared/components/SearchField';

/**
 * Search field with bottom margin for modal dialogs and wizards.
 */
export default function ModalSearchBar({ value, onChange, placeholder, inputRef }) {
  return (
    <SearchField
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="mb-3"
      inputRef={inputRef}
    />
  );
}

ModalSearchBar.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
};

ModalSearchBar.defaultProps = {
  value: '',
  placeholder: 'Search assets...',
};
